import { render } from "./Highendlove.vue?vue&type=template&id=bbeec9ee&scoped=true"
import script from "./Highendlove.vue?vue&type=script&lang=js"
export * from "./Highendlove.vue?vue&type=script&lang=js"

import "./Highendlove.vue?vue&type=style&index=0&id=bbeec9ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbeec9ee"]])

export default __exports__